import { render } from "./self-enroll-success.vue?vue&type=template&id=a8194bf4&lang=pug"
import script from "./self-enroll-success.vue?vue&type=script&lang=js"
export * from "./self-enroll-success.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__